import {TriggerSearchResult, DirectSearchResult} from "../../../types";

export const mapToDirectSearch = (r: TriggerSearchResult): DirectSearchResult => ({
    id: r.topicId + (r.segmentId ? `-${r.segmentId}` : ""),
    title: r.topicTitle,
    snippet: r.description ?? "",
    url: r.url,
    score: r.score ?? 0,
    metadata: {
        topicId: r.topicId,
        topicType: r.topicType,
        topicTypeid: r.topicTypeid,
        resourceTypeid: r.resourceTypeid,
        segmentId: r.segmentId,
    },
});
